import React             from 'react';
import TextAreaComponent from './TextAreaComponent';

const SpecialInstruction = (props) => {
  const { parameters } = props
  const name = 'special_instructions';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextAreaComponent
      label="Special Instruction"
      name={name}
      onChange={onChange}
      value={parameters[name] || ''}
      groupName={props.groupName}
      rows={props.rows} />
  );
};

export default SpecialInstruction;
